import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login if we're not already on login page and have a 401 from auth endpoints
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      // Don't redirect if this is just the initial auth check
      if (error.config?.url === '/auth/me') {
        // Initial auth check failed (user not logged in) - this is normal
        return Promise.reject(error);
      }
      // Clear auth and redirect to login for actual 401 errors
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
